import { useTranslation } from "react-i18next";
import { ReadOnlyClaim } from "../../../../redux/apiSpecifications/apiClaims";
import { FormRow } from "../../../../style/form";
import {
  DatePickerStyled,
  InputTextStyled,
  SwitchStyled,
} from "../../../../style/Input";
import { RowSpacer } from "../../../../style/containers";
import SelectVehicleType from "../../../Inputs/SelectVehicleType";
import { VehicoleTypeType } from "../../../../types/claim.types";
import FormModal from "../../../Modals/FormModal";
import { ButtonConfirm } from "../../../Layout/Buttons";
import { FlexWrapper } from "../../../../style/FlexWrapper";

interface IPolicyInfoFormProps {
  model: ReadOnlyClaim;
  disableForm?: boolean;
  isModal?: boolean;
  onEditPolicyData?: () => void;
  onChange?: (value: any, field: string) => void;
}

const PolicyInfoForm = ({
  model,
  disableForm,
  onChange,
}: IPolicyInfoFormProps) => {
  const { t } = useTranslation();

  const handleOnChange = (value: any, field: string) => {
    if (onChange) onChange(value, field);
  };

  return (
    <>
      {/* {!isModal && (
        <FlexWrapper gap="1em" justifyContent="flex-end">
         <ButtonConfirm onClick={() => onEditPolicyData && onEditPolicyData()}>
            {t("BUTTONS.edit-policy")!}
          </ButtonConfirm>
        </FlexWrapper>
      )} */}
   
      <FormRow>
        <InputTextStyled
          label={t("LABELS.company")}
          placeholder={t("PLACEHOLDERS.company")}
          onChange={(value) => {}}
          required={true}
          value={model.company}
          disabled={true}
        />

        <RowSpacer />

        <div
          style={{
            flex: 1,
            display: "flex",
          }}
        >
          <InputTextStyled
            label={t("LABELS.policy-number")}
            placeholder={t("PLACEHOLDERS.policy-number")}
            onChange={(value) => {}}
            required={true}
            value={model.policy?.number}
            disabled={true}
          />

          <RowSpacer />

          <SwitchStyled
            label={t("LABELS.administrative-compliance")}
            onChange={(value) =>
              handleOnChange(value, "administrativeCompliance")
            }
            unCheckedChildren={t("switch-no")}
            checkedChildren={t("switch-yes")}
            checked={model.policy?.administrativeCompliance}
            disabled={disableForm}
          />
        </div>

        <div
          style={{
            flex: 1,
            display: "flex",
          }}
        >
          <DatePickerStyled
            label={t("LABELS.effect-date")}
            format="YYYYMMDD"
            placeholder={"gg/mm/aaaa"}
            required={true}
            value={model.policy?.effectDate}
            onChange={(value) => {}}
            disabled={true}
          />

          <RowSpacer />

          <DatePickerStyled
            label={t("LABELS.expiration-date")}
            format="YYYYMMDD"
            placeholder={"gg/mm/aaaa"}
            required={true}
            value={model.policy?.expirationDate}
            onChange={(value) => {}}
            disabled={true}
          />
        </div>
      </FormRow>

      <FormRow>
        <InputTextStyled
          label={t("LABELS.plate-number")}
          placeholder={t("PLACEHOLDERS.plate-number")}
          onChange={(value) => handleOnChange(value, "plateNumber")}
          required={true}
          value={model.policy?.insuredProperty?.plateNumber}
          disabled={true}
        />

        <RowSpacer />

        <InputTextStyled
          label={t("LABELS.chassis-number")}
          placeholder={t("PLACEHOLDERS.chassis-number")}
          onChange={(value) => handleOnChange(value, "chassisNumber")}
          required={true}
          value={model.policy?.insuredProperty?.chassisNumber}
          disabled={disableForm}
        />

        <RowSpacer />

        <SelectVehicleType
          label={t("LABELS.vehicle-type")}
          required={true}
          value={model.policy?.insuredProperty?.type as VehicoleTypeType}
          onChange={(value) => handleOnChange(value, "type")}
          disabled={disableForm}
        />

        <RowSpacer />

        <InputTextStyled
          label={t("LABELS.brand")}
          placeholder={t("PLACEHOLDERS.brand")}
          onChange={(value) => handleOnChange(value, "brand")}
          required={true}
          value={model.policy?.insuredProperty?.brand}
          disabled={disableForm}
        />

        <RowSpacer />

        <InputTextStyled
          label={t("LABELS.model")}
          placeholder={t("PLACEHOLDERS.model")}
          onChange={(value) => handleOnChange(value, "model")}
          required={true}
          value={model.policy?.insuredProperty?.model}
          disabled={disableForm}
        />
      </FormRow>
    </>
  );
};

export default PolicyInfoForm;

interface IPolicyInfoFormModalProps {
  open: boolean;
  claim?: ReadOnlyClaim;
  onCancel: () => void;
  onConfirm: () => void;
}

export const PolicyInfoFormModal = ({
  open,
  claim,
  onCancel,
  onConfirm,
}: IPolicyInfoFormModalProps) => {
  return (
    <FormModal
      open={open}
      isConfirmButtonDisabled={false}
      width={900}
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      <PolicyInfoForm model={claim!} disableForm={false} />
    </FormModal>
  );
};
